import './App.css';
import { FaJs, FaReact, FaCss3Alt, FaHtml5, FaLinkedin, FaGithubSquare } from "react-icons/fa";
import { TbBrandCSharp } from "react-icons/tb";
import { FaFlutter } from "react-icons/fa6";
import { AiOutlineConsoleSql } from "react-icons/ai";
import NAITLogo from './img/newnait.png';
import TRULogo from './img/newtru.png';
import Me from './img/ME LOL.png';
import CoLogo from './img/Certified Origins Logo Centered.png';
import SongrLogo from './img/SONGR Logo.png';
import { Fade } from "react-awesome-reveal";

function Home() {
    return (
      <div className='container'>
        <div style={{position: 'absolute', right: '0', marginTop: '1rem', marginRight: '1rem'}}>
          <a href='https://www.linkedin.com/in/lucas-r-75262a13b/'><FaLinkedin size={50}/></a>
          <a href='https://github.com/Lrobert6'><FaGithubSquare size={50}/></a>
        </div>
        
        <div className='flex-container' style={{justifyContent: 'space-evenly'}}>
          
        </div>
        <div className='flex-container bio-div'>
          <div>
            <img src={Me} alt='Lucas Robert' width='50%' style={{borderRadius: '40%', marginTop: '20%', maxWidth: '50%', minWidth: '50%'}}/>
          </div>
          <div className='inner-bio-div' style={{marginRight: '10%', marginTop: '10%'}}>
            <h1>Lucas Robert</h1>
            <hr style={{borderBottom: '1px solid white', width: '70%', marginLeft: '15%'}}/>
            <p style={{marginTop: '15px'}}>My name is Lucas Robert, and I am an aspiring <strong>Software Developer</strong> based in <strong>Edmonton, Alberta</strong>. I am passionate about exploring new ways to create seamless functionalities and intuitive designs which enhance user experience. I take pride in my keen eye for detail, my goal to always keep learning, and my can-do attitude.</p>
          </div>
        </div>
        <div className='flex-container' style={{flexDirection: 'column', marginTop: '7.5rem', width: '80%', marginLeft: '10%'}}>
            <h2 style={{marginLeft:'15px'}}>Technical Skills</h2>
            <div className='flex-container skills-wall' style={{marginTop: '1rem'}}>
              <div className='flex-container skills-wall-inner' style={{width: '100%', justifyContent: 'space-between', paddingTop: '3rem', paddingBottom: '1.5rem', paddingLeft: '3rem', paddingRight: '3rem'}}>
                <div className='icon-container'>
                  <FaJs size={40} className='icon-hover' />
                  <p className='icon-text'>JavaScript</p>
                </div>
                <div className='icon-container'>
                  <FaReact size={40} className='icon-hover' />
                  <p className='icon-text'>React</p>
                </div>
                <div className='icon-container'>
                  <FaCss3Alt size={40} className='icon-hover' />
                  <p className='icon-text'>CSS</p>
                </div>
                <div className='icon-container'>
                  <FaHtml5 size={40} className='icon-hover' />
                  <p className='icon-text'>HTML</p>
                </div>
                <div className='icon-container'>
                  <TbBrandCSharp size={40} className='icon-hover' />
                  <p className='icon-text'>C#</p>
                </div>
                <div className='icon-container'>
                  <FaFlutter size={40} className='icon-hover' />
                  <p className='icon-text'>Flutter</p>
                </div>
                <div className='icon-container'>
                  <AiOutlineConsoleSql size={40} className='icon-hover' />
                  <p className='icon-text'>SQL</p>
                </div>
              </div>
              
            </div>
          </div>
        <div className='flex-container' style={{flexDirection: 'column', marginTop: '7.5rem', marginBottom: '7.5rem'}}>
          <h2 className='education-h2' style={{marginLeft:'15px'}}>Education</h2>
          <div className='flex-container' style={{justifyContent: 'space-evenly'}}>
            <div className='flex-container'>
              <img className='school-img' src={NAITLogo} alt='Northern Alberta Institute of Technology' height='200px'/>
              <div className='school-div' style={{display: 'flex', flexDirection: 'column', textAlign: 'left', marginTop: '3rem'}}>
                <p>Northern Alberta Institute of Technology</p>
                <p style={{fontSize: '2rem'}}><strong>Diploma</strong> - Computer Software Development</p>
                <p>Graduated December 2024</p>
              </div>
            </div>
            <div className='flex-container'>
              <img className='school-img' src={TRULogo} alt='Thompson Rivers University' height='200px'/>
              <div className='school-div' style={{display: 'flex', flexDirection: 'column', textAlign: 'left', marginTop: '3rem'}}>
                <p>Thompson Rivers University</p>
                <p style={{fontSize: '2rem'}}><strong>Degree</strong> - Bachelor of Computing Science</p>
                <p>Expected Graduation 2026</p>
              </div>
            </div>
            
          </div>
        </div>
        <Fade>
          <div className='flex-container' style={{flexDirection: 'column', width: '80%', marginLeft: '10%', paddingBottom: '10%'}}>
            <h2 style={{marginLeft:'15px', marginBottom: '15px'}}>Projects</h2>
            <div className='project-wall'>
              <div className='project-card'>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '2.5%'}}>
                  <img className='project-img' src={CoLogo} alt='Certified Origins' height='30%'/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '2.5%', width: '60%'}} className='project-p-div'>
                  <p className='project-p' style={{fontSize: '1.25rem'}}>Certified Origins was the result of my Capstone Project during my time at NAIT. This system was developed for a real client within 2 months by myself and 4 other developers.</p>
                  <p className='project-p' style={{fontSize: '1.25rem', marginTop: '1rem'}}>Certified Origins is a prototype system designed to help consumers make more informed purchasing decisions, and reward businesses that focus on sustainable production and ethical practices. Producers can upload detailed product information including relevant certifications, transportation history, components, and customized attributes, which will be displayed to a consumer upon scanning the QR code.</p>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '20%', marginLeft: '1%', marginRight: '1%'}} className='project-button-div'>
                  <a href='https://certifiedorigins.space/#/login' target='_blank'><button className='project-button' style={{backgroundColor: '#8DA9C4', color: 'white', border: 'none', fontSize: '2rem', borderRadius: '20px', padding: '.5rem'}}>Visit Live Demo</button></a>
                </div>
              </div>
              <div className='project-card'>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '2.5%'}}>
                  <img className='project-img' src={SongrLogo} alt='SongR' height='30%'/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '2.5%', width: '60%'}}  className='project-p-div'>
                  <p className='project-p' style={{fontSize: '1.25rem'}}>SONGR is a project that relies heavily on Spotify's Developer APIs to supply users with song recommendations. </p>
                  <p className='project-p' style={{fontSize: '1.25rem', marginTop: '1rem'}}>SONGR uses a combination of APIs and a voting system to suggest relevant songs to a user, based on a song they input. Unfortunately, after deprecation of several important API's, this project has been paused. More information regarding future, now defunct plans for this project, can be found on the GitHub repository.</p>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '20%', marginLeft: '1%', marginRight: '1%'}} className='project-button-div'>
                  <a href='https://github.com/Lrobert6/song-recommender' target='_blank' style={{marginBottom: '1rem'}}><button className='project-button' style={{backgroundColor: '#8DA9C4', color: 'white', border: 'none', fontSize: '2rem', borderRadius: '20px', padding: '.5rem'}}>Visit GitHub</button></a>
                  <a href='https://song-recommender-azure.vercel.app/' target='_blank'><button className='project-button' style={{backgroundColor: '#8DA9C4', color: 'white', border: 'none', fontSize: '2rem', borderRadius: '20px', padding: '.5rem'}}>Visit Live Demo</button></a>
                </div>
              </div>
            </div>
          </div>
        </Fade>
        
      </div>
    );
  }
  
  export default Home;